/** 表示中のチャットを再読み込みせず、親ページからの埋め込みを再確認する。 */
export function renewWidgetEmbedProof(widget: HTMLIFrameElement, origin: string, messageId: string): () => void {
  const frame = document.createElement("iframe");
  frame.hidden = true;
  frame.title = "サポートの接続確認";
  frame.referrerPolicy = "origin";
  const url = new URL("/widget/embed-proof", origin);
  url.searchParams.set("parentHost", window.location.hostname);
  url.searchParams.set("messageId", messageId);
  frame.src = url.toString();
  const stop = () => {
    window.clearTimeout(timeout);
    window.removeEventListener("message", receive);
    frame.remove();
  };
  const receive = (event: MessageEvent) => {
    if (event.source !== frame.contentWindow || event.origin !== origin) return;
    const data: unknown = event.data;
    if (typeof data !== "object" || data === null) return;
    const response = data as Record<string, unknown>;
    if (response.type !== "nest-support-widget:embed-proof:response" || response.messageId !== messageId) return;
    if (widget.isConnected) widget.contentWindow?.postMessage(response, origin);
    stop();
  };
  const timeout = window.setTimeout(stop, 12_000);
  window.addEventListener("message", receive);
  document.body.appendChild(frame);
  return stop;
}
